import { render, staticRenderFns } from "./Metas_mensais.vue?vue&type=template&id=2996efb2&scoped=true&"
import script from "./Metas_mensais.vue?vue&type=script&lang=js&"
export * from "./Metas_mensais.vue?vue&type=script&lang=js&"
import style0 from "./Metas_mensais.vue?vue&type=style&index=0&id=2996efb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2996efb2",
  null
  
)

export default component.exports